import clsx from 'clsx';
import { HubertBadge } from 'components/HubertUI/HubertBadge';
import HubertPopover from 'components/HubertUI/HubertPopover';
import HubertTooltip from 'components/HubertUI/HubertTooltip';
import IsAI from 'components/IsAi';
import { format } from 'date-fns';
import { Link } from 'react-router';
import { useScoreInterview } from '../scoring.context';
import ChatCollection from './ChatCollection';

const Chat = () => {
  const { chat, chatFilter, interview, aiDetectionSummary, autoUpdateSummary } = useScoreInterview();

  if (!chat) {
    return null;
  }
  const customContainer = document.getElementById('main-content') as HTMLElement;

  return (
    <div className={clsx('flex flex-col justify-start gap-4', 'p-2', 'pr-3')}>
      <div className={clsx('flex flex-row justify-start gap-2', 'bg-info-100', 'rounded-md p-2')}>
        <IsAI aiDetection={aiDetectionSummary} />
        {autoUpdateSummary && autoUpdateSummary.validationTags?.length
          ? autoUpdateSummary.validationTags.map((tag, index) => {
              return (
                <HubertBadge key={`validation-tag-${index}`} variant={'info'}>
                  {tag}
                </HubertBadge>
              );
            })
          : null}

        {interview &&
        interview.relations &&
        interview.relations.manualScore &&
        interview.relations.manualScore.tagged_by.length ? (
          <HubertTooltip>
            <HubertTooltip.Trigger>
              <HubertBadge variant={'info'}>Scored by: {interview.relations.manualScore.tagged_by}</HubertBadge>
            </HubertTooltip.Trigger>
            <HubertTooltip.Content portalContent={true} portalElement={customContainer} side="bottom">
              <div>
                {interview.relations.manualScore.updated_at ? (
                  <div>Date: {format(new Date(interview.relations.manualScore.updated_at), 'PPPPpppp')}</div>
                ) : (
                  <div>Date: Unknown</div>
                )}
              </div>
            </HubertTooltip.Content>
          </HubertTooltip>
        ) : null}

        {interview && interview.reusage && interview.reusage.isReused ? (
          <HubertPopover>
            <HubertPopover.Trigger>
              <HubertBadge variant={'info'}>Reused interview</HubertBadge>
            </HubertPopover.Trigger>
            <HubertPopover.Content className={clsx('flex flex-col justify-between gap-4', 'p-4')}>
              <div>
                Reused interview:
                <Link to={`/score/${interview.reusage.reusedInterviewId}`} className="ml-2">
                  {interview.reusage.reusedInterviewId}
                </Link>
              </div>
              <div>Reused question IDs:</div>
              {interview.reusage.reusedIds?.map((x) => {
                return (
                  <Link key={x} to={`/questions/${x}`} className="ml-2">
                    {x}
                  </Link>
                );
              })}
            </HubertPopover.Content>
          </HubertPopover>
        ) : null}

        {interview && interview.resetInterview && interview.resetInterview.length > 0 ? (
          <HubertPopover>
            <HubertPopover.Trigger>
              <HubertBadge variant={'info'}>Reset/restarted interview</HubertBadge>
            </HubertPopover.Trigger>
            <HubertPopover.Content className={clsx('flex flex-col justify-between gap-4', 'p-4')}>
              <div>
                <div className="text-sm font-medium">Reset/restarted on these question IDs:</div>
                <ul>
                  {interview.resetInterview.map((x) => {
                    return (
                      <li key={x.reset_on_question_id} className="text-sm text-gray-500">
                        {x.reset_on_question_id} ({x.reset_method === 'text' ? 'Text' : 'Button'})
                      </li>
                    );
                  })}
                </ul>
              </div>
            </HubertPopover.Content>
          </HubertPopover>
        ) : null}
      </div>

      {chat.map((collection, idx: number) => {
        if (collection.questionId === 'bonus_booster') return null;
        if (chatFilter.isFiltered) {
          if (chatFilter.questionIds.includes(collection.questionId)) {
            return <ChatCollection key={`chat-collection-${idx}`} collection={collection} />;
          } else {
            return null;
          }
        } else {
          return <ChatCollection key={`chat-collection-${idx}`} collection={collection} />;
        }
      })}
    </div>
  );
};

export default Chat;
